<template>
  <p class="article__description">
    <slot />
  </p>
</template>

<style lang="scss" scoped>
  .article__description {
    margin-bottom: $spacer30;
    clear: left;
  }
</style>
